import { render, staticRenderFns } from "./TransferDrawer.vue?vue&type=template&id=3f5ec6c0&scoped=true"
import script from "./TransferDrawer.vue?vue&type=script&lang=js"
export * from "./TransferDrawer.vue?vue&type=script&lang=js"
import style0 from "./TransferDrawer.vue?vue&type=style&index=0&id=3f5ec6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ec6c0",
  null
  
)

export default component.exports